import {apiUpdateAvailable} from "../api/apiObservables";

export const GETTER_SCROLL_TO_EL = 'shrared/getScrollToEl';
export const GETTER_SHOW_OVERLAY = 'shared/getShowOverlay';
export const GETTER_SHOW_PREVIEW = 'shared/getShowPreview';
export const GETTER_SHOW_NAV     = 'shared/getShowNav';
export const GETTER_VERSION      = 'shared/getVersion';
export const GETTER_HAS_UPDATE   = 'shared/getHasUpdate';
export const GETTER_VERSION_CHECKED = 'shared/getVersionChecked';

export const MUTATE_SET_SCROLL_TO_EL = 'shared/setSctollToEl';
export const MUTATE_SHOW_OVERLAY = 'shared/setShowOverlay';
export const MUTATE_SHOW_PREVIEW = 'shared/setShowPreview';
export const MUTATE_SHOW_NAV     = 'share/setShowNav';
export const MUTATE_TOGGLE_OVERLAY = 'shared/setToggleOverlay';
export const MUTATE_TOGGLE_PREVIEW = 'shared/setTogglePreview';
export const MUTATE_TOGGLE_NAV     = 'shared/setToggleNav';
export const MUTATE_VERSION        = 'shared/setVersion';
export const MUTATE_HAS_UPDATE     = 'shared/setHasUpdate';
export const MUTATE_VERSION_CHECKED= 'shared/setVersionChecked';

export const ACTION_CHECK_UPDATES  = 'shared/checkUpdates';

const state = {
  scrollToEl: null,
  showOverlay: false,
  showPreview: false,
  showNav: false,
  version: 0,
  hasUpdate: false,
  versionChecked: false
};

const getters = {
  [GETTER_SCROLL_TO_EL]: (state) => state.scrollToEl,
  [GETTER_SHOW_OVERLAY]: (state) => state.showOverlay,
  [GETTER_SHOW_PREVIEW]: (state) => state.showPreview,
  [GETTER_SHOW_NAV]    : (state) => state.showNav,
  [GETTER_VERSION]     : (state) => state.version,
  [GETTER_HAS_UPDATE]  : (state) => state.hasUpdate,
  [GETTER_VERSION_CHECKED] : (state) => state.versionChecked
};

const mutations = {
  [MUTATE_SET_SCROLL_TO_EL]: (state, payload) => {
    state.scrollToEl = payload;
  },
  [MUTATE_SHOW_OVERLAY]: (state, payload) => {
    state.showOverlay = payload;
  },
  [MUTATE_SHOW_PREVIEW]: (state, payload) => {
    state.showPreview = payload;
  },
  [MUTATE_SHOW_NAV]: (state, payload) => {
    state.showNav = payload;
  },
  [MUTATE_TOGGLE_OVERLAY]: (state) => {
    state.showOverlay = !state.showOverlay;
  },
  [MUTATE_TOGGLE_PREVIEW]: (state) => {
    state.showPreview = !state.showPreview;
  },
  [MUTATE_TOGGLE_NAV]: (state) => {
    state.showNav = !state.showNav;
  },
  [MUTATE_HAS_UPDATE]: (state, payload) => {
    state.hasUpdate = payload;
  },
  [MUTATE_VERSION]: (state, payload) => {
    state.version = payload;
  },
  [MUTATE_VERSION_CHECKED] : (state, payload) => {
    state.versionChecked = payload;
  }
};

const actions = {
  [ACTION_CHECK_UPDATES]: (context) => {
    if (context.getters[GETTER_VERSION_CHECKED]) {
      return {currVersion: context.getters[GETTER_VERSION], siteVersion: context.getters[GETTER_VERSION] }
    } else {
      console.log("Checking...");
      return new Promise((resolve, reject) => apiUpdateAvailable().toPromise()
        .then((result) => {
          context.commit(MUTATE_VERSION_CHECKED, true);
          context.commit(MUTATE_VERSION, result.currVersion);
          if (result.currVersion < result.siteVersion) {
            context.commit(MUTATE_HAS_UPDATE, true);
          } else {
            context.commit(MUTATE_HAS_UPDATE, false);
          }
          resolve(result);
        }).catch((err) => reject(err))
      );
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}
